import Form from 'react-bootstrap/Form';

function InputIcon({
  label,
  type,
  placeholder,
  controlId,
  values,
  handleChange,
  handleBlur,
  errors,
  children,
  disabled,
}) {
  // This is used if the value coming from props is nested inside an object
  const splittedString = controlId.split('.');

  let obj = {};

  Object.assign(obj, splittedString);
  const numberOfProperties = Object.keys(obj).length;

  let nestedValue = null;
  let nestedErrors = null;

  let useNestedValue = false;

  if (numberOfProperties > 1) {
    if (numberOfProperties === 2) {
      // Accessing the nested value
      nestedValue = values[obj[0]][obj[1]];
      nestedErrors = errors[obj[0]]?.[obj[1]];
    } else if (numberOfProperties === 3) {
      nestedValue = values[obj[0]][obj[1]][obj[2]];
      nestedErrors = errors[obj[0]]?.[obj[1]]?.[obj[2]];
    }
    useNestedValue = true;
  }

  return (
    <div className='position-relative'>
      <div
        className='position-absolute'
        style={{
          top: '12px',
          left: '6px',
        }}
      >
        {children}
      </div>
      <Form.Group controlId={controlId}>
        <Form.Label className={label ? '' : 'd-none'}>{label}</Form.Label>
        <Form.Control
          className='py-2'
          style={{ paddingLeft: '30px' }}
          type={type}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={handleBlur}
          isInvalid={!!(useNestedValue ? nestedErrors : errors[controlId])}
          value={useNestedValue ? nestedValue : values[controlId]}
          disabled={disabled}
        ></Form.Control>
        <Form.Control.Feedback type='invalid'>
          {useNestedValue ? nestedErrors : errors[controlId]}
        </Form.Control.Feedback>
      </Form.Group>
    </div>
  );
}

export default InputIcon;
